import { z } from "zod";
import { calendarYear } from "@/shared/schedule";

// Apart from the rest of the schemas, whose messages bring the whole of the settings copy: the
// shell and the landing page validate their search with these, and a route's search rides in
// every first load.

/** The pages the settings window opens, in the address as `?settings=`. */
export const SETTINGS_KEYS = [
  "profile",
  "preferences",
  "notifications",
  "security",
  "personalization",
  "general",
  "features",
  "ai",
  "billing",
  "export",
  "working-week",
  "holidays",
  "leave-types",
  "invoices",
  "payslips",
] as const;

/**
 * `menu` is the list of pages a phone opens on, where there is no room for it beside a page.
 * `holidaysYear` is the year the holidays page shows, when it is not the company's own.
 */
export const openSettingsSearch = z.object({
  settings: z
    .enum([...SETTINGS_KEYS, "menu"])
    .optional()
    .catch(undefined),
  holidaysYear: calendarYear.optional().catch(undefined),
});

/** The `?failed=` a refused emailed link opens the app with. */
export const linkFailure = z.enum([
  "link_used",
  "email_taken",
  "account_held",
  "signed_out",
  "only_google",
]);

export const linkLandingSearch = z.object({
  failed: linkFailure.optional().catch(undefined),
});
